import { MSLF } from "@lgp/shared/constants";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AppProvider from "./components/AppProvider";
import "./css/blue.scss";

const { MSLF_APP_ID, MSLF_APP_SCRIPT_ID } = MSLF;

// The app can only run in an iframe.
if (window.location === window.parent.location) {
  throw new Error(`The app must be in an iframe.`);
}

const script = document.getElementById(MSLF_APP_SCRIPT_ID);

// Create a React mount node if it does not exist.
const root = document.getElementById(MSLF_APP_ID);
if (!root) {
  throw new Error(`Root element ${MSLF_APP_ID} not found in DOM.`);
}

const url = new URL(window.location.href);
const urlSearchParams = url.searchParams;

const formConfig =
  urlSearchParams.get("form-config") ||
  root.dataset.formConfig ||
  script?.dataset.formConfig;
if (!formConfig) {
  throw new Error(`Lead form config not found in root element or script tag.`);
}

const parentUrl = new URL(urlSearchParams.get("referrer"));
const parentHostUrlParts = parentUrl.href.split("/");
const parentHost = parentHostUrlParts[0] + "//" + parentHostUrlParts[2];

let maxHeight = 0;

const resizeObserver = new ResizeObserver((entries) => {
  // https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
  window.requestAnimationFrame(() => {
    if (!Array.isArray(entries) || !entries.length) {
      return;
    }

    const e = entries[0];
    const width = e.target.clientWidth;
    const height = e.target.clientHeight;
    if (height > maxHeight) {
      maxHeight = height;
      window.top.postMessage(
        {
          action: "lgp:resize",
          payload: {
            width,
            height,
          },
        },
        parentHost
      );
    }
  });
});

resizeObserver.observe(root);

// Render the React App.
function renderApp() {
  const app = ReactDOM.createRoot(root);
  app.render(
    <React.StrictMode>
      <AppProvider
        parentHost={parentHost}
        parentUrl={parentUrl}
        formConfig={formConfig}
      >
        <App />
      </AppProvider>
    </React.StrictMode>
  );
}

if (root) {
  window.addEventListener("load", renderApp);
}
